import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<React.StrictMode><App /></React.StrictMode>);
// force rebuild Thu May 21 14:41:41 UTC 2026
// Thu May 21 15:30:08 UTC 2026
// force deploy 1779380873
// logout fix 1779404016
// admin login fix 1779448097
// admin pages fix 1779449827
// account type selection 1779465062
// email confirmation ui 1779713213
// fix profile update 1779713574
// fix profiles table 1779832932
// fix mulheres table 1779834090
// fix maybeSingle 1779895228
// fix checkIsAdmin maybeSingle 1779980334
